<template>
    <div>
        <b-breadcrumb :items="items"></b-breadcrumb>
        <div>
            <h2 style="text-align: center" class="pt-4">ปรับเงินเดือนพนักงาน</h2>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">
                            เลือกวันที่
                        </label>
                        <div class="col-sm-4">
                            <date-picker
                                :lang="lang"
                                type="date"
                                class="text-center w-100"
                                :format="changeFormat"
                                v-model="date"
                                placeholder="วันที่">
                            </date-picker>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table mt-4">
                <table class="table-borderless"  align="center">
                    <tr class="header-border">
                        <td width="200">รหัสพนักงาน</td>
                        <td width="150">ค่าจ้าง(เก่า)</td>
                        <td width="150">ค่าจ้าง(ใหม่)</td>
                        <td width="250">ประเภทการจ้าง(เก่า)</td>
                        <td width="250">ประเภทการจ้าง(ใหม่)</td>
                        <td width="250">เบี้ยขยัน(เก่า)</td>
                        <td width="250">เบี้ยขยัน(ใหม่)</td>
                    </tr>
                    <tr v-for="(detail,index) in employeeList">
                        <td width="250">
                            <multiselect
                                v-model="detail.employee_id"
                                :options="optionEmployee"
                                placeholder="เลือกพนักงาน"
                                select-label=""
                                deselectLabel=""
                                :customLabel="employeeLabel"
                                @input="updateSalary(index)"
                                track-by="id">
                            </multiselect>
                        </td>
                        <td width="250">
                            <input v-model="detail.amount_old"
                                   type="number" class="form-control"
                                   readonly
                            />
                        </td>
                        <td width="250">
                            <input v-model="detail.amount"
                                   type="number" class="form-control"
                                   min="1" v-on:keypress="isNumber()"
                            />
                        </td>
                        <td width="150">
                            <b-select :options="optionPerday" v-model="detail.perday_old" disabled></b-select>
                        </td>
                        <td width="150">
                            <b-select :options="optionPerday" v-model="detail.perday"></b-select>
                        </td>
                        <td width="250">
                            <input v-model="detail.benefit_old"
                                   type="number" class="form-control"
                                   readonly
                            />
                        </td>
                        <td width="250">
                            <input v-model="detail.benefit"
                                   type="number" class="form-control"
                                   min="1" v-on:keypress="isNumber()"
                            />
                        </td>
                        <td width="100">
                            <!--เพิ่ม-->
                            <button type="button" class="btn btn-primary"
                                    @click="addList"
                                    v-if="employeeList.length == index+1">
                                <icon name="plus"></icon>
                            </button>
                            <!--ลบ-->
                            <button type="button" class="btn btn-danger"
                                    @click="removeList(index)"
                                    v-if="index+1 < employeeList.length">
                                <icon name="trash"></icon>
                            </button>
                        </td>
                    </tr>
                </table>
            </div>

            <div class="col text-center">
                <button type="button"
                        @click="saveForm"
                        class="btn btn-success">
                    <icon name="save"></icon>
                    บันทึก</button>
                &nbsp;&nbsp;
<!--                <button type="button"-->
<!--                        @click="goToOtherList"-->
<!--                        class="btn btn-outline-secondary">-->
<!--                    <icon name="times"></icon> ยกเลิก-->
<!--                </button>-->
            </div>
        </div>
    </div>

</template>

<script>
    import { mapState } from "vuex";
    import DatePicker from 'vue2-datepicker';
    import Multiselect from "vue-multiselect";
    import moment from "moment";

    import {
        canViewSuperAdmin
    } from "../../../../util/Permissions";
    export default {
        name: "employee-salary-form",
        components : {Multiselect,DatePicker},
        props: {
            status_bar: { default: false },
        },
        data(){
          return{
              items: [
                  {
                      text: 'บันทึกการปรับเงิน',
                      to: {name:"rate-salary"}
                  },
                  {
                      text: 'ปรับเงินเดือน',
                      active: true
                  }
              ],
              employeeList : [{
                  employee_id: [],
                  amount : "",
                  amount_old : "",
                  user_id: "",
                  date: "",
                  paid:'',
                  perday_old:'',
                  perday:'',
                  benefit_old:'',
                  benefit:'',
              }],
              date : '',
              changeFormat: {
                  stringify: (date) => {
                      let date_moment = moment(date).format('YYYY');
                      const year = parseInt(date_moment) + 543;
                      return date ? moment(date).format('DD/MM/'+year) : null
                  },
                  parse: (value) => {
                      return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                  }
              },
              lang: {
                  days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                  months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                  pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                  placeholder: {
                      date: 'วว/ดด/ปปปป',
                  }
              },
              optionEmployee : [],
              optionPerday : [
                  {value:1,text:'ต่อวัน'},
                  {value:3,text:'ค่อเดือน'},
                  {value:'',text:'ไม่ได้ตั้งค่า'},
              ],
          }
        },
        created(){
            this.$store.dispatch("Employee/getEmployeeAll_data").then(res=>{
                this.optionEmployee = res;
            });
        },
        computed:{
            canViewSuperAdmin,
            ...mapState({
                user:state=>{
                    return state.Auth.user;
                },
            }),
        },
        methods:{
            saveForm(){
                if(!this.date){
                    alert('กรุณาเลือกวันที่');
                }else{
                    this.employeeList.forEach(detail=>{
                        if(detail.employee_id != 0){
                            if(!detail.employee_id)alert('กรุณาเลือกพนักงานให้ครบ');
                            else detail.employee_id = detail.employee_id.id;
                        }
                        detail.user_id = this.user.id;
                        this.currentDate = moment().format("YYYY-MM-DD");
                        detail.date  = this.date ? moment(this.date).format("YYYY-MM-DD") : '';
                    })
                    this.$store.dispatch('Employee/updateSalaryEmployee',this.employeeList).then(()=>{
                        this.employeeList = [{
                            employee_id: [],
                            amount : "",
                            amount_old : "",
                            user_id: "",
                            date: "",
                            paid:'',
                            perday_old:'',
                            perday:'',
                            benefit_old:'',
                            benefit:'',
                        }];
                        this.date = '';
                        alert('ปรับเงินเดือนสำเร็จ');
                    })
                }

            },
            employeeLabel(option){
                return `${option.employee_no} - ${option.name}`
            },
            addList(){
                this.employeeList = [
                    ...this.employeeList,
                    {
                        employee_id: [],
                        amount : "",
                        amount_old : "",
                        user_id: "",
                        date: "",
                        paid: '',
                        perday_old: '',
                        perday: '',
                        benefit_old: '',
                        benefit: '',
                    }
                ];
            },
            removeList(index){
                this.employeeList = this.employeeList.filter(
                    (detail, itemIndex) => index !== itemIndex
                );
            },
            isNumber() {
                let evt = window.event;
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            updateSalary(index) {
                this.employeeList[index].amount_old = this.employeeList[index].employee_id.salary.salary;
                this.employeeList[index].amount = this.employeeList[index].employee_id.salary.salary;
                this.employeeList[index].paid = this.employeeList[index].employee_id.salary.paid_period;
                this.employeeList[index].perday_old = this.employeeList[index].employee_id.salary.salary_per_day;
                this.employeeList[index].perday = this.employeeList[index].employee_id.salary.salary_per_day;
                this.employeeList[index].benefit_old = this.employeeList[index].employee_id.work_benefit.benefit_amount;
                this.employeeList[index].benefit = this.employeeList[index].employee_id.work_benefit.benefit_amount;
            },
        }
    }
</script>

<style scoped>
    .header-border td{
        border: white solid 1px;
        color: white;
        background: rgba(255, 200, 0, 0.93);
    }
</style>
